"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Icon_1 = require("../../Icon");
var stylesImport = require("./DocumentCard.scss");
var styles = stylesImport;
var DocumentCardLogo = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardLogo, _super);
    function DocumentCardLogo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardLogo.prototype.render = function () {
        var logoIcon = this.props.logoIcon;
        return (React.createElement("div", { className: Utilities_1.css('ms-DocumentCardLogo', styles.logo) },
            React.createElement(Icon_1.Icon, { iconName: logoIcon })));
    };
    return DocumentCardLogo;
}(Utilities_1.BaseComponent));
exports.DocumentCardLogo = DocumentCardLogo;
//# sourceMappingURL=DocumentCardLogo.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/DocumentCard/DocumentCardLogo.js
// module id = 963
// module chunks = 0